export const ReasonsForPractitionerLeavingProgramme = {
    OTHER: '7049458d-cd48-4e74-883d-9b984e65feee',
};
//# sourceMappingURL=reason-for-practitioner-leaving-programme.dto.js.map